import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {CommunicationConfigurationModel} from '../communicationConfiguration.model';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {CommunicationConfigurationEmailConverter} from '../../../email/common/api/model/converter/communicationConfigurationEmail.converter';

@Injectable()
export class CommunicationConfigurationConverter extends HttpModelConverter<CommunicationConfigurationModel> {

    constructor(private email: CommunicationConfigurationEmailConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): CommunicationConfigurationModel {
        return new CommunicationConfigurationModel();
    }

    protected enrichObject(result: CommunicationConfigurationModel, src: CommunicationConfigurationModel) {
        result.priority = this.lovValueSummaryConverter.convert(src.priority);
        result.emailConfiguration = this.email.convert(src.emailConfiguration);
    }


}
